export default [
    {
        "id": "mfr-brands",
        "plugin": "mfr-brands",
        "pluginId": 7,
        "name": "manufacturer-brand",
        "css": require('./mfr-brands/css').default,
        "cssMobile": require('./mfr-brands/cssMobile').default,
        "scss": require('./mfr-brands/scss').default,
        "scssMobile": require('./mfr-brands/scssMobile').default,
        "html": require('./mfr-brands/html').default
    }
]